// extracted by mini-css-extract-plugin
module.exports = {"TabsBar":"TabsBar_TabsBar__3CuZc","TabsContainer":"TabsBar_TabsContainer__2eWUa","ContactUsLink":"TabsBar_ContactUsLink__hXAi0"};